<script>
    import { loginRequestOtpAction } from 'domain/auth/auth.actions';
    import AuthStore from 'store/auth';
    import { useFocus } from 'svelte-navigator';
    import ButtonBase from '../common/ButtonBase.svelte';
    import Icon from '../components/Icon.svelte';
    import { TEST_TOKEN_RESPONSE, TEST_ACCOUNT_NUMBER } from '../services/utils';

    import { useNavigate } from 'svelte-navigator';

    const navigate = useNavigate();
    const registerFocus = useFocus();

    let mobile;
    let loading = false;
    let errorMessage = ""

    const login = async () => {
        try {
            AuthStore.setMobile(mobile);
            loading = true
            if ( mobile.endsWith(TEST_ACCOUNT_NUMBER) ) {
                AuthStore.login(TEST_TOKEN_RESPONSE);
                navigate('/choose-number');
                return;
            }
            
            await loginRequestOtpAction(mobile);

            navigate('/otp-login', {
                replace: true,
            });
        } catch (error) {
            const { mobile, message } = error
            errorMessage = mobile || message
        } finally {
            loading = false
        }
    };
</script>

<div id="phone-login" class="row content">
    <section class="display-flex">
        <div class="logo marginTop2r"><Icon icon="logo" size="96" /></div>

        <div class="heading">Enter your phone number</div>

        <div class="country-phone">
            <div class="selected-country">
                <Icon icon="flag" />
                <Icon icon="dropdown" />
            </div>
            <input
                id="phone"
                class="phone-number-field"
                bind:value={mobile}
                use:registerFocus
                type="tel"
            />
        </div>

        <span style="margin-bottom: 3.5rem;"
            >We would send a verification code to this number</span
        >

        <ButtonBase disabled={!mobile} style="width: 100%;" on:click={login} {loading} hasBg={true}>
            <button class={`button ${loading ? 'loading' : ''}`} disabled={!mobile}> Login </button>
        </ButtonBase>
        <div class="error-msg">{ errorMessage }</div>
    </section>
</div>

<style lang="scss">
    input {
        outline: none;
    }
    #phone-login {
        section {
            margin: 0 1.25rem;
            .heading {
                margin-bottom: 1rem;
            }
            span {
                align-self: flex-start;
                font-weight: 400;
                font-size: 12px;
                line-height: 20px;
                color: #474b50;
            }

            .country-phone {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 8px;
                background: #ffffff;
                border: 1px solid #eeeeee;
                border-radius: 4px;
            }
            .selected-country {
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;
                gap: 8px;
                padding: 1em;
            }
            .phone-number-field {
                width: 100%;
                height: 100%;
                padding-left: 0.5em;
                border: 0;
                border-left: 1px solid #d9e2e7;
                color: #474b50;
            }
        }
    }
    button:disabled, .button.loading {
        background-color: #7cbdd7;
    }
    .error-msg {
        color: #a10e0e;
        font-size: 10px;
        margin-top: 5px;
    }
</style>
